<template>
  <div>
    <app-header></app-header>
    <div class="container-fluid" style="background-color: white;">
      <div class="display-4">Cilinders Online</div>
      <hr>
    </div>

    <div class="container-fluid">
      <button class="btn btn-info mb-2" style="width: 500px; height: 400px"  @click="goto880"><img class="centered-and-cropped mb-2" :src="'/src/assets/880.PNG'" height = "200 " width= "400"><h4>Nieuwe standaardcilinder(s) bestellen</h4><p>(standaard geleverd met 3 sleutels)</p><h2>880 reeks</h2></button>
      <button class="btn btn-info mb-2" style="width: 500px; height: 400px"><img class="centered-and-cropped mb-2" :src="'/src/assets/970.PNG'" height = "200 " width= "400"><h4>Nieuwe veiligheidcilinder(s) bestellen</h4><p>(standaard geleverd met 3 sleutels)</p><h2>970 reeks</h2></button>
      <button class="btn btn-info mb-2" style="width: 500px; height: 400px"><img class="centered-and-cropped mb-2" :src="'/src/assets/960.PNG'" height = "200 " width= "400"><h4>Nieuwe veiligheidcilinder(s) bestellen</h4><p>(standaard geleverd met 3 sleutels)</p><h2>960 reeks</h2></button>
    </div>
  </div>
</template>

<script>
import AppHeader from "../intro/AppHeader";
import store from '../../ClientApp/store';
import projectsteps from '../../ClientApp/helpers/project-steps';

export default {
  methods: {
    goto880() {
      this.$router.push("/cilinder880");
    }
  }
}
</script>

<style scoped>
    @media (min-width: 1500px) {
        .container-fluid {
        width: 80%;
        }
    }
    @media (min-width: 2000px) {
        .container-fluid {
        width: 60%;
        }
    }
    .lnk{
      cursor:pointer;
    }

    .centered-and-cropped { object-fit: contain }
    
</style>


// WEBPACK FOOTER //
// src/components/cilinders/CilinderIntro.vue